import React from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { useAuth } from '../contexts/AuthContext';

const Navbar = () => {
  const { user, logout, isAuthenticated, isAdmin } = useAuth();
  const navigate = useNavigate();

  const handleLogout = () => {
    logout();
    navigate('/');
  };

  return (
    <nav className="bg-white shadow-sm border-b border-gray-100" data-testid="navbar">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="flex justify-between items-center h-20">
          <div className="flex items-center space-x-8">
            <Link to="/" className="flex items-center space-x-3" data-testid="navbar-logo">
              <img src="/logo.png" alt="Ment-Ally Logo" className="h-12 w-12" />
              <span className="text-2xl font-bold gradient-text">Ment-Ally</span>
            </Link>
            <div className="hidden md:flex space-x-6">
              <Link
                to="/search"
                className="text-gray-700 hover:text-teal-600 px-3 py-2 text-base font-medium transition-colors"
                data-testid="navbar-search-link"
              >
                Find Services
              </Link>
              <Link
                to="/emergency"
                className="text-gray-700 hover:text-teal-600 px-3 py-2 text-base font-medium transition-colors"
                data-testid="navbar-emergency-link"
              >
                Crisis Support
              </Link>
            </div>
          </div>

          <div className="flex items-center space-x-4">
            {isAuthenticated ? (
              <>
                {isAdmin ? (
                  <Link
                    to="/admin"
                    className="text-gray-700 hover:text-teal-600 px-4 py-2 text-base font-medium transition-colors"
                    data-testid="navbar-admin-link"
                  >
                    Admin Panel
                  </Link>
                ) : isProvider ? (
                  <>
                    <Link
                      to="/register-service"
                      className="text-gray-700 hover:text-teal-600 px-4 py-2 text-base font-medium transition-colors"
                      data-testid="navbar-register-service-link"
                    >
                      Register Service
                    </Link>
                    <Link
                      to="/my-services"
                      className="text-gray-700 hover:text-teal-600 px-4 py-2 text-base font-medium transition-colors"
                      data-testid="navbar-my-services-link"
                    >
                      My Services
                    </Link>
                  </>
                ) : null}
                <div className="flex items-center space-x-3 pl-4 border-l border-gray-200">
                  <span className="text-sm text-gray-600 font-medium" data-testid="navbar-user-name">
                    {user?.nickname || user?.name}
                  </span>
                  <button
                    onClick={handleLogout}
                    className="px-4 py-2 rounded-lg text-sm font-medium text-gray-700 hover:bg-gray-100 transition-colors"
                    data-testid="navbar-logout-button"
                  >
                    Logout
                  </button>
                </div>
              </>
            ) : (
              <Link
                to="/login"
                className="btn-gradient px-6 py-2.5 rounded-lg text-base font-semibold"
                data-testid="navbar-login-link"
              >
                Login / Register
              </Link>
            )}
          </div>
        </div>
      </div>
    </nav>
  );
};

export default Navbar;
